<template>
  <svg
    class="guest-login-icon"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M672 178c-3.7 0-7.5-1.3-10.5-3.9-8.1-7.1-16.7-13.8-25.6-19.9-7.3-5-9.1-15-4.1-22.3 5-7.3 15-9.1 22.3-4.1 9.9 6.8 19.5 14.3 28.5 22.1 6.7 5.8 7.3 15.9 1.5 22.6-3.2 3.7-7.6 5.5-12.1 5.5zM635.4 675.5c-4.8 0-9.5-2.1-12.7-6.2-3.6-4.7-7.3-9.2-11.1-13.7l-12.4-14.7 16.7-9.5c87.7-50.2 142.2-144 142.2-244.7 0-67.7-24.3-133.1-68.5-184.3-5.8-6.7-5-16.8 1.7-22.6 6.7-5.8 16.8-5.1 22.6 1.7 49.2 56.9 76.3 129.8 76.3 205.2 0 105.9-54.1 204.9-142.4 262.7l0.3 0.3c5.4 7 4.1 17-2.8 22.4-3 2.3-6.5 3.4-9.9 3.4z"
      fill="currentColor"
      opacity="0.82"
    />
    <path
      d="M481.3 548.4c-63.9 0-122.4-35.1-152.5-91.5-4.2-7.8-1.2-17.5 6.6-21.7 7.8-4.2 17.5-1.3 21.7 6.6 24.6 46 72.2 74.6 124.3 74.6 52.1 0 99.7-28.6 124.3-74.5 4.2-7.8 13.8-10.7 21.7-6.6 7.8 4.2 10.7 13.9 6.6 21.7-30.4 56.4-88.8 91.4-152.7 91.4z"
      fill="currentColor"
      opacity="0.82"
    />
    <path
      d="M896 928h-17c-0.5-51.8-20.3-95.5-49.7-116.9 27.5-20 46.6-59.6 49.3-107.1H896c8.8 0 16-7.2 16-16s-7.2-16-16-16H672c-8.8 0-16 7.2-16 16s7.2 16 16 16h25c2.7 47.4 21.9 87 49.3 107.1-29.3 21.4-49.2 65.2-49.7 116.9H672c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16zM729.1 704h117.5c-3.6 49.4-29 89.2-58.8 89.2-29.7 0-55.1-39.8-58.7-89.2z m58.7 125c31.7 0 58.5 45.1 59.2 99H728.7c0.6-53.9 27.4-99 59.1-99z"
      fill="#0F82E4"
      class="accent"
    />
    <path
      d="M311.3 711.4L466.9 906c3 3.8 7.6 6 12.5 6 4.8 0 9.4-2.2 12.5-5.9l148.2-183.5c5.5-6.9 4.5-17-2.4-22.5s-16.9-4.5-22.5 2.4l-135.7 168-149.6-187.2c5.8-8.1 11.8-16 18.1-23.7l12.3-15.1-17.2-9.2C251.2 586.1 194 490.8 194 386.7c0-155.5 126.5-282.1 282-282.1 43.8 0 85.8 9.8 124.7 29 7.9 3.9 17.5 0.7 21.4-7.2 3.9-7.9 0.7-17.5-7.3-21.4-43.4-21.5-90.1-32.4-138.9-32.4-173.2 0-314 140.9-314 314.1 0 109.6 56.8 210.4 149.5 267.5-50.5 66.8-82.3 145.3-92.4 228.6l-1.1 15.3c-0.6 11.1 0.5 32.1 14.8 47.2 6.4 6.8 18 14.8 37.1 14.8h338c8.8 0 16-7.2 16-16s-7.2-16-16-16H270c-9.3 0-12.7-3.6-13.9-4.8-4.4-4.6-6.6-13.3-6.1-22.9l1-14.3c7.5-62.1 28.1-121.5 60.3-174.7z"
      fill="currentColor"
      opacity="0.82"
    />
  </svg>
</template>

<script>
export default {
  name: 'GuestLoginIcon'
}
</script>

<style scoped>
.guest-login-icon {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
